export default {
  priceLimit: "Votre plafond financier",
  volumeLimit: "Vos droits à cubage",
};
